/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function unvoidAny(i: any): NotVoid {
  return (i as any) || null
}

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export function unvoid(i: void): NotVoid {
  return unvoidAny(i)
}

export type ActionRes =
  | { error: stringI18n; success?: never }
  | { error?: stringI18n | undefined; success: stringI18n | undefined }

export function actionRes(i: ActionRes): ActionRes {
  return i
}
